import api from "../../../api/clinique/_patients";

const state = () => ({
    patient: {},
    nom_patient: "",
    patient_est_assure: 0,
    info_assurance: [],

    liste_situation_matrimoniales: [],
    liste_civilites: [],
    info_patient: [],
    liste_sexes: [],

    patient_insurance_info: {},

    chosen_patient: {}
});

// getters
const getters = {
    patient: (state) => {
        return state.patient;
    },

    chosen_patient: (state) => {
        return state.chosen_patient;
    },

    nomPatient: (state) => {
        return state.nom_patient;
    },

    patient_est_assure: (state) => {
        return state.patient_est_assure;
    },

    info_assurance: (state) => {
        return state.info_assurance;
    },

    liste_civilites: (state) => {
        return state.liste_civilites;
    },

    liste_situation_matrimoniales: (state) => {
        return state.liste_situation_matrimoniales;
    },

    info_patient: (state) => {
        return state.info_patient
    },

    liste_sexes: (state) => {
        return state.liste_sexes
    },

    patient_insurance_info: (state) => {
        return state.patient_insurance_info;
    },
};
// mutations
const mutations = {
    SET_PATIENT(state, pat) {
        state.patient = pat;
    },

    SET_CHOSEN_PATIENT(state, patient) {
        state.chosen_patient = patient;
    },

    SET_NOM_PATIENT(state, pat) {
        state.nom_patient = pat;
    },

    SET_PATIENT_EST_ASSURE(state, est_assure) {
        state.patient_est_assure = est_assure;
    },

    SET_PATIENT_INFO_ASSURANCE(state, info) {
        state.info_assurance = info;
    },

    SET_LISTE_CIVILITES(state, pat) {
        state.liste_civilites = pat;
    },

    SET_LISTE_SITUATION_MATRIMONIALES(state, pat) {
        state.liste_situation_matrimoniales = pat;
    },

    SET_INFO_PATIENT(state, patient) {
        state.info_patient = patient
    },

    SET_LISTE_SEXES(state, patient) {
        state.liste_sexes = patient
    },

    SET_PATIENT_INSURANCE_INFO(state, insurance_info) {
        state.patient_insurance_info = insurance_info
    },
};

// actions
const actions = {
    getPatient({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getPatient(id).then((response) => {
                
                commit("SET_PATIENT", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getPatientName({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getPatientName(id).then((response) => {
                commit("SET_NOM_PATIENT", response.nom + " " + response.prenoms);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getSexes({ commit }) {
        return new Promise((resolve, reject) => {
            api.getSexes().then((response) => {
                commit("SET_LISTE_SEXES", response)
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    createPatient({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.createPatient(data).then((response) => {
                commit("SET_PATIENT", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    checkIfPatientEstAssure({ commit }, patient_id) {
        return new Promise((resolve, reject) => {
            api.checkIfPatientEstAssure(patient_id).then((response) => {
                commit("SET_PATIENT_EST_ASSURE", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getPatientInfoAssurance({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getPatientInfoAssurance(data).then((response) => {
                commit("SET_PATIENT_INFO_ASSURANCE", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getSituationsMatrimoniales({ commit }) {
        return new Promise((resolve, reject) => {
            api.getSituationsMatrimoniales().then((response) => {
                commit("SET_LISTE_SITUATION_MATRIMONIALES", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getListeCivilite({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeCivilite().then((response) => {
                commit("SET_LISTE_CIVILITES", response);
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getInfoPatient({ commit }, patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoPatient(patient_id).then(
                response => {
                    commit('SET_INFO_PATIENT', response)
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },

    savePatient({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.savePatient(data).then(
                response => {
                    dispatch
                    // commit('SET_PATIENT', response)
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },

    getPatientInsuranceInfo({ commit }, patient_id) {
        return new Promise((resolve, reject) => {
            api.getPatientInsuranceInfo(patient_id).then(
                response => {
                    commit('SET_PATIENT_INSURANCE_INFO', response)
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};